import { postSSE } from "api/sse";
import type { ResumeRequest, SSEEvent, StreamRequest } from "./types";
import {
  appendEvent,
  finishEntry,
  startResumeEntry,
  startStreamEntry,
} from "./debugLog";

const AGENT_API_HOST = process.env.REACT_APP_AGENT_API_HOST || "";

function requireHost(): string {
  if (!AGENT_API_HOST) {
    throw new Error(
      "REACT_APP_AGENT_API_HOST 환경변수가 설정되지 않았어요. .env 에 Agent 서버 호스트를 지정해 주세요."
    );
  }
  return AGENT_API_HOST;
}

export async function* streamCowork(
  req: StreamRequest,
  signal?: AbortSignal
): AsyncGenerator<SSEEvent> {
  const entryId = startStreamEntry(req);
  yield* withDebugCapture(
    entryId,
    postSSE<SSEEvent>(`${requireHost()}/cowork/stream`, req, signal)
  );
}

export async function* resumeCowork(
  req: ResumeRequest,
  signal?: AbortSignal
): AsyncGenerator<SSEEvent> {
  const entryId = startResumeEntry(req);
  yield* withDebugCapture(
    entryId,
    postSSE<SSEEvent>(`${requireHost()}/cowork/resume`, req, signal)
  );
}

async function* withDebugCapture(
  entryId: string,
  source: AsyncGenerator<SSEEvent>
): AsyncGenerator<SSEEvent> {
  try {
    for await (const event of source) {
      appendEvent(entryId, event);
      yield event;
    }
    finishEntry(entryId, "done");
  } catch (err) {
    finishEntry(
      entryId,
      "error",
      err instanceof Error ? err.message : String(err)
    );
    throw err;
  }
}
